<template>
  <div class="list-budget-templates">
    <AppPageHeader title="Budget Templates" :action="{ title: 'Add new template', to: { name: 'CreateBudgetTemplate' } }" />

    <BaseTable
      :is-loading="isPending"
      :error="error"
      :items="budgetTemplates"
      :fields="tableFields"
      :is-searchable="true"
      :clickable="true"
      :paginate="true"
      :next-page="() => !isPlaceholderData && nextPage()"
      :prev-page="prevPage"
      :page="currentPage"
      :total-records="totalRecords"
      :total-pages="totalPages"
      :number-per-page="numPerPage"
      @on-search="(val) => search(val)"
      @row-selected="onRowSelected"
    >
      <template #title-data="data">
        <router-link :to="{ name: 'ShowBudgetTemplate', params: { id: data.row.id } }">
          {{ data.row.title }}
        </router-link>
      </template>
      <template #cost-data="data">
        <span>{{ currency(data.row.cost) }}</span>
      </template>
      <template #scopeOfWork-data="data">
        <span class="line-clamp-1 truncate inline-block max-w-64" v-html="data.row.scopeOfWork"></span>
      </template>
    </BaseTable>
  </div>
</template>

<script lang="ts" setup>
import { currency } from '@/utils'
import { useQueryClient } from '@tanstack/vue-query'
import BudgetTemplateService from '@/services/BudgetTemplateService'
import BaseTable from '@/components/base/BaseTable.vue'
import AppPageHeader from '@/components/app/AppPageHeader.vue'
import { useSearchablePagination } from '@/composables/useSearchablePagination'
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'

const tableFields = [
  { key: 'title', label: 'Title', sortable: true },
  { key: 'scopeOfWork', label: 'Scope of Work' },
  { key: 'cost', label: 'Cost', sortable: true },
]

const queryClient = useQueryClient()
const budgetTemplateService = new BudgetTemplateService()
const numPerPage = ref(25)

const {
  results: budgetTemplatesData,
  isPending,
  error,
  search,
  isPlaceholderData,
  currentPage,
  totalPages,
  totalRecords,
  nextPage,
  prevPage,
} = useSearchablePagination({
  indexName: 'budgetItems',
  service: budgetTemplateService,
  numPerPage: numPerPage.value,
  defaultOrderBy: 'title',
  defaultOrderDir: 'asc'
})

const budgetTemplates = computed(() => {
  if (!budgetTemplatesData.value) return []

  budgetTemplatesData.value.forEach(budgetTemplate => {
    queryClient.setQueryData(['budgetTemplate', budgetTemplate.id], budgetTemplate)
  })

  return budgetTemplatesData.value
})

const $router = useRouter()
const onRowSelected = (row: any) => {
  $router.push({ name: 'ShowBudgetTemplate', params: { id: row.id } })
}
</script>
